// import React, { useState, useRef, useEffect } from "react";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { Mic, MicOff, Loader2 } from "lucide-react";
// import axios from "axios";
// import { decodedToken } from "./utils";
// import { tvControlData, translations as tvTranslations } from "../data/tvControlData";
// import { useLanguage } from "../language/LanguageContext";
// import "./App.css";

// // Function to resample audio buffer to 16kHz
// const resampleAudio = async (audioBuffer, targetSampleRate = 16000) => {
//   const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//   const sourceSampleRate = audioBuffer.sampleRate;

//   if (sourceSampleRate === targetSampleRate) {
//     return audioBuffer; // No resampling needed
//   }

//   const offlineContext = new OfflineAudioContext(
//     audioBuffer.numberOfChannels,
//     (audioBuffer.length * targetSampleRate) / sourceSampleRate,
//     targetSampleRate
//   );

//   const bufferSource = offlineContext.createBufferSource();
//   bufferSource.buffer = audioBuffer;
//   bufferSource.connect(offlineContext.destination);
//   bufferSource.start(0);

//   const resampledBuffer = await offlineContext.startRendering();
//   return resampledBuffer;
// };

// // Function to convert AudioBuffer to WAV Blob
// const audioBufferToWavBlob = (audioBuffer) => {
//   const numChannels = audioBuffer.numberOfChannels;
//   const sampleRate = audioBuffer.sampleRate;
//   const length = audioBuffer.length * numChannels * 2 + 44;
//   const buffer = new ArrayBuffer(length);
//   const view = new DataView(buffer);

//   let offset = 0;

//   // Write WAV header
//   const writeString = (str) => {
//     for (let i = 0; i < str.length; i++) {
//       view.setUint8(offset++, str.charCodeAt(i));
//     }
//   };

//   writeString("RIFF");
//   view.setUint32(4, 36 + audioBuffer.length * numChannels * 2, true);
//   writeString("WAVE");
//   writeString("fmt ");
//   view.setUint32(offset, 16, true); // Sub-chunk size
//   offset += 4;
//   view.setUint16(offset, 1, true); // Audio format (PCM)
//   offset += 2;
//   view.setUint16(offset, numChannels, true); // Number of channels
//   offset += 2;
//   view.setUint32(offset, sampleRate, true); // Sample rate
//   offset += 4;
//   view.setUint32(offset, sampleRate * numChannels * 2, true); // Byte rate
//   offset += 4;
//   view.setUint16(offset, numChannels * 2, true); // Block align
//   offset += 2;
//   view.setUint16(offset, 16, true); // Bits per sample
//   offset += 2;
//   writeString("data");
//   view.setUint32(offset, audioBuffer.length * numChannels * 2, true);
//   offset += 4;

//   // Write interleaved samples
//   for (let i = 0; i < audioBuffer.length; i++) {
//     for (let channel = 0; channel < numChannels; channel++) {
//       const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
//       view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
//       offset += 2;
//     }
//   }

//   return new Blob([buffer], { type: "audio/wav" });
// };

// function Audiopage() {
//   const navigate = useNavigate();
//   const { language, setLanguage, t } = useLanguage();
//   const [audioFile, setAudioFile] = useState(null);
//   const [uploadaudioFile, setUploadAudioFile] = useState(null);
//   const [audioPreview, setAudioPreview] = useState(null);
//   const [languageCode, setLanguageCode] = useState("en");
//   const [gender, setGender] = useState("");
//   const [audioDetails, setAudioDetails] = useState([]);
//   const [age, setAge] = useState("");
//   const [audiotext, setAudiotext] = useState("");
//   const [userInputText, setUserInputText] = useState("");
//   const [transcribedText, setTranscribedText] = useState("");
//   const [translationText, settranslationText] = useState("");
//   const [editableTranscribedText, setEditableTranscribedText] = useState("");
//   const [loading, setLoading] = useState({});
//   const [transcribedStatus, setTranscribedStatus] = useState(null);
//   const [isTranscribing, setIsTranscribing] = useState(false);
//   const [audioBuffers, setAudioBuffers] = useState({});
//   const [activeAudio, setActiveAudio] = useState(null);
//   const [playing, setPlaying] = useState({});
//   const [mode, setMode] = useState("record");
//   const [isRecording, setIsRecording] = useState(false);
//   const [uploaderEmail, setUploaderEmail] = useState("");
//   const fileInputRef = useRef();
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const ServerUrl = "https://voice-sample.tpvai.com/b/";

//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedVoiceControl, setSelectedVoiceControl] = useState("");
//   const [sampleUtterances, setSampleUtterances] = useState([]);
//   const [selectedUtterance, setSelectedUtterance] = useState("");
//   const [voiceControlOptions, setVoiceControlOptions] = useState([]);
//   const [channelName, setChannelName] = useState("");

//   const [zipFileName, setZipFileName] = useState("");
//   const [showUploadedAudios, setShowUploadedAudios] = useState(false);
//   const [filterLanguage, setFilterLanguage] = useState("");
//   const [filterVoiceControl, setFilterVoiceControl] = useState("");
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [zipDownloadUrl, setZipDownloadUrl] = useState("");
//   const [isPreparingZip, setIsPreparingZip] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [isFetchingAudios, setIsFetchingAudios] = useState(false);

//   const decode = decodedToken();
//   const isAdmin = decode?.role === "admin";
//   const emailUser = localStorage.getItem("email");

//   const languageMap = {
//     english: "en",
//     portuguese: "pt",
//     spanish: "es",
//     spanish_ar: "es-ar",
//     spanish_mx: "es_mx",
//     spanish_cl: "es-cl",
//     spanish_pe: "es-pe",
//     french: "fr",
//     german: "de",
//     italian: "it",
//     chinese_tw: "zh-TW",
//     chinese_cn: "zh-CN",
//     chinese_sg: "zh-SG",
//     dutch_be: "nl-BE",
//     dutch_nl: "nl-NL",
//   };

//   const getTranscriptionLanguageCode = (code) => {
//     if (["es", "es-ar", "es_mx", "es-cl", "es-pe"].includes(code)) return "es";
//     if (["zh-TW", "zh-CN", "zh-SG"].includes(code)) return "zh";
//     if (["nl-BE", "nl-NL"].includes(code)) return "nl";
//     const transcriptionMap = {
//       en: "en",
//       pt: "pt",
//       fr: "fr",
//       de: "de",
//       it: "it",
//     };
//     return transcriptionMap[code] || "en";
//   };

//   const categories = Object.keys(tvControlData);

//   useEffect(() => {
//     if (selectedCategory && tvControlData[selectedCategory]) {
//       setVoiceControlOptions(Object.keys(tvControlData[selectedCategory]));
//       setSelectedVoiceControl("");
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when category changes
//     } else {
//       setVoiceControlOptions([]);
//       setSelectedVoiceControl("");
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when category is cleared
//     }
//   }, [selectedCategory]);

//   useEffect(() => {
//     if (selectedCategory && selectedVoiceControl && tvControlData[selectedCategory][selectedVoiceControl]) {
//       const langKey =
//         language === "en" ? "english" :
//         language === "pt" ? "portuguese" :
//         language === "es" ? "spanish" :
//         language === "es-ar" ? "spanish_ar" :
//         language === "es_mx" ? "spanish_mx" :
//         language === "es-cl" ? "spanish_cl" :
//         language === "es-pe" ? "spanish_pe" :
//         language === "fr" ? "french" :
//         language === "de" ? "german" :
//         language === "it" ? "italian" :
//         language === "zh-TW" ? "chinese_tw" :
//         language === "zh-CN" ? "chinese_cn" :
//         language === "zh-SG" ? "chinese_sg" :
//         language === "nl-BE" ? "dutch_be" :
//         language === "nl-NL" ? "dutch_nl" : "english";
//       const utterances = tvControlData[selectedCategory][selectedVoiceControl][langKey] || tvControlData[selectedCategory][selectedVoiceControl]["english"];
//       setSampleUtterances(utterances || []);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when voice control changes
//     } else {
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when voice control is cleared
//     }
//   }, [selectedCategory, selectedVoiceControl, language]);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     navigate("/");
//   };

//   const handleAdminPage = () => {
//     navigate("/admin");
//   };

//   const handleFileSelect = (fileName) => {
//     let updatedSelection;
//     if (selectedFiles.includes(fileName)) {
//       updatedSelection = selectedFiles.filter((file) => file !== fileName);
//     } else {
//       updatedSelection = [...selectedFiles, fileName];
//     }
//     setSelectedFiles(updatedSelection);
//     setIsAllSelected(updatedSelection.length === filteredAudioDetails.length);
//   };

//   const handleSelectAll = () => {
//     if (isAllSelected) {
//       setSelectedFiles([]);
//       setIsAllSelected(false);
//     } else {
//       const allFileNames = filteredAudioDetails.map((audio) => audio.fileName);
//       setSelectedFiles(allFileNames);
//       setIsAllSelected(true);
//     }
//   };

//   const handleLanguageChange = (e) => {
//     const selectedLanguage = e.target.value;
//     let newLanguage;
//     switch (selectedLanguage) {
//       case "english": newLanguage = "en"; break;
//       case "portuguese": newLanguage = "pt"; break;
//       case "spanish": newLanguage = "es"; break;
//       case "spanish_ar": newLanguage = "es-ar"; break;
//       case "spanish_mx": newLanguage = "es_mx"; break;
//       case "spanish_cl": newLanguage = "es-cl"; break;
//       case "spanish_pe": newLanguage = "es-pe"; break;
//       case "french": newLanguage = "fr"; break;
//       case "german": newLanguage = "de"; break;
//       case "italian": newLanguage = "it"; break;
//       case "chinese_tw": newLanguage = "zh-TW"; break;
//       case "chinese_cn": newLanguage = "zh-CN"; break;
//       case "chinese_sg": newLanguage = "zh-SG"; break;
//       case "dutch_be": newLanguage = "nl-BE"; break;
//       case "dutch_nl": newLanguage = "nl-NL"; break;
//       default: newLanguage = "en";
//     }
//     setLanguage(newLanguage);
//     const langKey = selectedLanguage;
//     setLanguageCode(languageMap[langKey] || "");
//     setSelectedCategory("");
//     setSelectedVoiceControl("");
//     setSampleUtterances([]);
//     setSelectedUtterance("");
//     setAudiotext("");
//     setChannelName(""); // Clear channel name when language changes
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//     setChannelName("");
//   };

//   const handleVoiceControlChange = (e) => {
//     setSelectedVoiceControl(e.target.value);
//     setChannelName("");
//   };

//   const handleUtteranceClick = (utterance) => {
//     setSelectedUtterance(utterance);
//     setAudiotext(utterance);
//     setChannelName("");
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 10 * 1024 * 1024) {
//         alert("File size should be 10MB or less.");
//         return;
//       }
//       const fileExtension = file.name.split(".").pop();
//       if (fileExtension !== "mp3" && fileExtension !== "wav") {
//         alert("Only .mp3 or .wav files are allowed.");
//         return;
//       }

//       try {
//         const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//         const arrayBuffer = await file.arrayBuffer();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//         const resampledBuffer = await resampleAudio(audioBuffer, 16000);
//         const resampledBlob = audioBufferToWavBlob(resampledBuffer);
//         const resampledFile = new File([resampledBlob], file.name.replace(/\.[^.]+$/, ".wav"), { type: "audio/wav" });

//         setAudioFile(resampledFile);
//         setUploadAudioFile(file);
//         setAudioPreview(URL.createObjectURL(file));
//         setTranscribedText("");
//         settranslationText("");
//         setEditableTranscribedText("");
//         setTranscribedStatus(null);

//         if (languageCode) await transcribeAudio(resampledFile);
//         else Swal.fire("Warning", t("Please select a language before uploading an audio file."), "warning");
//       } catch (error) {
//         Swal.fire("Error", t("Failed to process audio file: ") + error.message, "error");
//       }
//     }
//   };

//   const startRecording = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       mediaRecorderRef.current = new MediaRecorder(stream);
//       audioChunksRef.current = [];
//       mediaRecorderRef.current.ondataavailable = (event) => audioChunksRef.current.push(event.data);
//       mediaRecorderRef.current.onstop = async () => {
//         const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
//         const audioFileUpload = new File([audioBlob], "recorded-audio.wav", { type: "audio/wav" });
//         const arrayBuffer = await audioBlob.arrayBuffer();
//         const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//         const resampledBuffer = await resampleAudio(audioBuffer, 16000);
//         const resampledBlob = audioBufferToWavBlob(resampledBuffer);
//         const audioFile = new File([resampledBlob], "recorded-audio.wav", { type: "audio/wav" });

//         setAudioFile(audioFile);
//         setUploadAudioFile(audioFileUpload);
//         setAudioPreview(URL.createObjectURL(audioBlob));
//         setTranscribedText("");
//         settranslationText("");
//         setEditableTranscribedText("");
//         setTranscribedStatus(null);
//         stream.getTracks().forEach((track) => track.stop());

//         if (languageCode) await transcribeAudio(audioFile);
//         else Swal.fire("Warning", t("Please select a language before recording audio."), "warning");
//       };
//       mediaRecorderRef.current.start();
//       setIsRecording(true);
//     } catch (error) {
//       Swal.fire("Error", t("Failed to access microphone: ") + error.message, "error");
//     }
//   };

//   const stopRecording = () => {
//     if (mediaRecorderRef.current && isRecording) {
//       mediaRecorderRef.current.stop();
//       setIsRecording(false);
//     }
//   };

//   const transcribeAudio = async (file) => {
//     setIsTranscribing(true);
//     setUserInputText("");
//     const formData = new FormData();
//     formData.append("audio", file);
//     formData.append("language", getTranscriptionLanguageCode(languageCode));
//     try {
//       const response = await axios.post(`${ServerUrl}api/stt/upload-audio`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if (response.status === 200) {
//         setTranscribedText(response.data.transcribedText.transcription);
//         settranslationText(response.data.transcribedText.translation);
//         setEditableTranscribedText(response.data.transcribedText.transcription);
//       }
//     } catch (error) {
//       Swal.fire("Error", error.response?.data?.message || t("Failed to transcribe audio"), "error");
//     } finally {
//       setIsTranscribing(false);
//     }
//   };

//   const toggleAudio = async (fileName, audioId) => {
//     if (activeAudio && activeAudio.id !== audioId && activeAudio.instance) {
//       activeAudio.instance.pause();
//       activeAudio.instance.currentTime = 0;
//       setPlaying((prev) => ({ ...prev, [activeAudio.id]: false }));
//     }
//     if (!audioBuffers[audioId]) {
//       setLoading((prev) => ({ ...prev, [audioId]: true }));
//       try {
//         const response = await axios.post(`${ServerUrl}stream_audio`, { file: fileName }, { responseType: "blob" });
//         const audioBlob = new Blob([response.data], { type: "audio/mpeg" });
//         const audioUrl = URL.createObjectURL(audioBlob);
//         const audio = new Audio(audioUrl);
//         setAudioBuffers((prev) => ({ ...prev, [audioId]: audioUrl }));
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play();
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       } catch (error) {
//         Swal.fire("Error", t("Failed to load audio: ") + error.message, "error");
//       } finally {
//         setLoading((prev) => ({ ...prev, [audioId]: false }));
//       }
//     } else {
//       const audio = activeAudio?.id === audioId ? activeAudio.instance : new Audio(audioBuffers[audioId]);
//       const isPlaying = playing[audioId];
//       if (isPlaying) {
//         audio.pause();
//         audio.currentTime = 0;
//         setPlaying((prev) => ({ ...prev, [audioId]: false }));
//         setActiveAudio(null);
//       } else {
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play().catch((err) => console.error("Play error:", err));
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       }
//     }
//   };

//   const handleDownload = async (fileName) => {
//     try {
//       const response = await axios.get(`${ServerUrl}download_audio?file=${encodeURIComponent(fileName)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       Swal.fire("Error", t("Failed to download audio: ") + error.message, "error");
//     }
//   };

//   const handleSave = async () => {
//     if (!audioFile || !languageCode || !gender || !age || !transcribedText || !transcribedStatus || !selectedVoiceControl || !uploaderEmail) {
//       Swal.fire("Error", t("Please fill in all fields, including uploader email, upload or record an audio file, and verify transcription."), "error");
//       return;
//     }

//     if (transcribedStatus === "not_ok" && !userInputText.trim()) {
//       Swal.fire("Error", t("Please provide the user input when transcription is Not OK."), "error");
//       return;
//     }

//     if (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim()) {
//       Swal.fire("Error", t("Please enter a channel name."), "error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("audio", uploadaudioFile);
//     formData.append("email", emailUser);
//     formData.append("uploaderEmail", uploaderEmail);
//     formData.append("audiotext", selectedVoiceControl || "na");
//     formData.append("audioLabel", `${gender} - ${age}`);
//     formData.append("audioLanguage",
//       language === "en" ? "english" :
//       language === "pt" ? "portuguese" :
//       language === "es" ? "spanish" :
//       language === "es-ar" ? "spanish_ar" :
//       language === "es_mx" ? "spanish_mx" :
//       language === "es-cl" ? "spanish_cl" :
//       language === "es-pe" ? "spanish_pe" :
//       language === "fr" ? "french" :
//       language === "de" ? "german" :
//       language === "it" ? "italian" :
//       language === "zh-TW" ? "chinese_tw" :
//       language === "zh-CN" ? "chinese_cn" :
//       language === "zh-SG" ? "chinese_sg" :
//       language === "nl-BE" ? "dutch_be" :
//       language === "nl-NL" ? "dutch_nl" : "");
//     formData.append("languageCode", language);
//     formData.append("transcribedText", transcribedText);
//     formData.append("userInputText", transcribedStatus === "ok" ? "" : userInputText);
//     formData.append("transcribedStatus", transcribedStatus);
//     formData.append("translation", translationText);
//     formData.append("ChannelName", selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" ? channelName : "na");
//     try {
//       const response = await axios.post(`${ServerUrl}uploads`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if (response.status === 200 || response.status === 201) {
//         Swal.fire("Success", t("Audio successfully uploaded!"), "success");
//         handleDeleteUploadedFile();
//         setUploaderEmail("");
//         setChannelName("");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || t("Something went wrong"), "error");
//     }
//   };

//   const handleDeleteUploadedFile = () => {
//     if (audioPreview) URL.revokeObjectURL(audioPreview);
//     setAudioFile(null);
//     setAudioPreview(null);
//     setAudiotext("");
//     setGender("");
//     setAge("");
//     setTranscribedText("");
//     settranslationText("");
//     setEditableTranscribedText("");
//     setUserInputText("");
//     setTranscribedStatus(null);
//     setSelectedCategory("");
//     setSelectedVoiceControl("");
//     setSelectedUtterance("");
//     setChannelName("");
//     setIsRecording(false);
//     if (mode === "upload" && fileInputRef.current) fileInputRef.current.value = null;
//   };

//   const fetchAudioDetails = async () => {
//     setIsFetchingAudios(true);
//     setShowUploadedAudios(true);
//     try {
//       const response = await axios.get(`${ServerUrl}audios?email=${emailUser}`);
//       if (response.status === 200) {
//         const sortedData = response.data.data.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
//         setAudioDetails(sortedData);
//       } else {
//         throw new Error(t("Failed to fetch audio details"));
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || t("Failed to fetch audio details"), "error");
//     } finally {
//       setIsFetchingAudios(false);
//     }
//   };

//   const getTranslatedText = (key, type) => {
//     const langKey =
//       language === "en" ? "english" :
//       language === "pt" ? "portuguese" :
//       language === "es" ? "spanish" :
//       language === "es-ar" ? "spanish_ar" :
//       language === "es_mx" ? "spanish_mx" :
//       language === "es-cl" ? "spanish_cl" :
//       language === "es-pe" ? "spanish_pe" :
//       language === "fr" ? "french" :
//       language === "de" ? "german" :
//       language === "it" ? "italian" :
//       language === "zh-TW" ? "chinese_tw" :
//       language === "zh-CN" ? "chinese_cn" :
//       language === "zh-SG" ? "chinese_sg" :
//       language === "nl-BE" ? "dutch_be" :
//       language === "nl-NL" ? "dutch_nl" : "english";
//     const translationMap = type === "category" ? tvTranslations.categories : tvTranslations.voiceControls;
//     return translationMap[key]?.[langKey] || translationMap[key]?.["english"] || key;
//   };

//   const handleModeChange = (newMode) => setMode(mode === newMode ? "" : newMode);

//   const prepareZip = async () => {
//     if (selectedFiles.length === 0) {
//       Swal.fire("Warning", t("Please select at least one audio file to download as ZIP."), "warning");
//       return;
//     }
//     setIsPreparingZip(true);
//     try {
//       const response = await axios.post(`${ServerUrl}prepare_audio_zip`, {
//         files: selectedFiles,
//         filterVoiceControl: filterVoiceControl,
//         filterLanguage: filterLanguage,
//       });
//       if (response.status === 200) {
//         setZipDownloadUrl(response.data.downloadUrl);
//         Swal.fire("Success", t("ZIP file prepared successfully!"), "success");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.response?.data?.message || t("Failed to prepare ZIP file"), "error");
//     } finally {
//       setIsPreparingZip(false);
//     }
//   };

//   const handleZipDownload = () => {
//     if (zipDownloadUrl) {
//       const link = document.createElement("a");
//       link.href = zipDownloadUrl;
//       link.setAttribute("download", "");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       setZipDownloadUrl("");
//       setSelectedFiles([]);
//     }
//   };

//   const filteredAudioDetails = audioDetails
//     .filter((audio) => {
//       const matchesLanguage = filterLanguage ? audio.audioLanguage === filterLanguage : true;
//       const matchesVoiceControl = filterVoiceControl ? audio.audiotext === filterVoiceControl : true;
//       return matchesLanguage && matchesVoiceControl;
//     })
//     .sort((a, b) => {
//       const langCompare = a.audioLanguage.localeCompare(b.audioLanguage);
//       if (langCompare !== 0) return langCompare;
//       return a.audiotext.localeCompare(b.audiotext);
//     });

//   const uniqueLanguages = [...new Set(audioDetails.map((audio) => audio.audioLanguage))].sort((a, b) =>
//     a.localeCompare(b)
//   );
//   const uniqueVoiceControls = [...new Set(audioDetails.map((audio) => audio.audiotext))].sort((a, b) =>
//     a.localeCompare(b)
//   );

//   return (
//     <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex flex-col justify-start items-center p-4 pt-10 pb-10 overflow-y-auto scroll-mt-32">
//       <div className="bg-white p-6 sm:p-8 md:p-10 rounded-xl shadow-xl space-y-6 w-full max-w-5xl">
//         <h1 className="text-2xl sm:text-3xl font-semibold text-center mb-6 text-gray-800">{t("Audio File Upload")}</h1>
//         <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
//           <button onClick={handleLogout} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
//             {t("Logout")}
//           </button>
//           {isAdmin && (
//             <button onClick={handleAdminPage} className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600">
//               {t("Admin Page")}
//             </button>
//           )}
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           <div className="mb-4 w-full">
//             <label htmlFor="language-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               {t("Select Language")}
//             </label>
//             <select
//               id="language-select"
//               value={
//                 language === "en" ? "english" :
//                 language === "pt" ? "portuguese" :
//                 language === "es" ? "spanish" :
//                 language === "es-ar" ? "spanish_ar" :
//                 language === "es_mx" ? "spanish_mx" :
//                 language === "es-cl" ? "spanish_cl" :
//                 language === "es-pe" ? "spanish_pe" :
//                 language === "fr" ? "french" :
//                 language === "de" ? "german" :
//                 language === "it" ? "italian" :
//                 language === "zh-TW" ? "chinese_tw" :
//                 language === "zh-CN" ? "chinese_cn" :
//                 language === "zh-SG" ? "chinese_sg" :
//                 language === "nl-BE" ? "dutch_be" :
//                 language === "nl-NL" ? "dutch_nl" : ""
//               }
//               onChange={handleLanguageChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Language")}</option>
//               <option value="english">English (EN)</option>
//               <option value="portuguese">Português (PT)</option>
//               <option value="spanish">Español (ES)</option>
//               <option value="spanish_ar">Español (AR)</option>
//               <option value="spanish_mx">Español (MX)</option>
//               <option value="spanish_cl">Español (CL)</option>
//               <option value="spanish_pe">Español (PE)</option>
//               <option value="french">Français (FR)</option>
//               <option value="german">Deutsch (DE)</option>
//               <option value="italian">Italiano (IT)</option>
//               <option value="chinese_tw">中文 (繁體, 台灣)</option>
//               <option value="chinese_cn">中文 (简体, 中国)</option>
//               <option value="chinese_sg">中文 (简体, 新加坡)</option>
//               <option value="dutch_be">Nederlands (BE)</option>
//               <option value="dutch_nl">Nederlands (NL)</option>
//             </select>
//           </div>

//           <div className="mb-4 w-full">
//             <label htmlFor="gender-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               {t("Select Gender")}
//             </label>
//             <select
//               id="gender-select"
//               value={gender}
//               onChange={(e) => { setGender(e.target.value); setAge(""); }}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Gender")}</option>
//               <option value="Female">{t("Female")}</option>
//               <option value="Male">{t("Male")}</option>
//             </select>
//           </div>

//           <div className="mb-4 w-full sm:col-span-2">
//             <label htmlFor="uploader-email" className="flex items-center text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               <span>{t("Uploader Email")}</span>
//               <span className="text-red-500 ml-1"></span>
//             </label>
//             <input
//               id="uploader-email"
//               type="email"
//               value={uploaderEmail}
//               onChange={(e) => setUploaderEmail(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm box-border"
//               placeholder={t("Enter uploader email")}
//               required
//             />
//           </div>

//           {gender && (
//             <div className="mb-4 w-full sm:col-span-2">
//               <label htmlFor="age-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//                 {t("Select Age Category")}
//               </label>
//               <select
//                 id="age-select"
//                 value={age}
//                 onChange={(e) => setAge(e.target.value)}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//               >
//                 <option value="">{t("Select Age Category")}</option>
//                 <option value="Kid">{t("Kid")}</option>
//                 <option value="Adult">{t("Adult")}</option>
//                 <option value="Older">{t("Older")}</option>
//               </select>
//             </div>
//           )}
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Category")}</label>
//             <select
//               value={selectedCategory}
//               onChange={handleCategoryChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Category")}</option>
//               {categories.map((category) => (
//                 <option key={category} value={category}>{getTranslatedText(category, "category")}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Voice Control")}</label>
//             <select
//               value={selectedVoiceControl}
//               onChange={handleVoiceControlChange}
//               disabled={!selectedCategory}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Voice Control")}</option>
//               {voiceControlOptions.map((option) => (
//                 <option key={option} value={option}>{getTranslatedText(option, "voiceControl")}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Sample Utterances")}</label>
//             <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg bg-gray-50 max-h-32 overflow-y-auto">
//               {sampleUtterances.length > 0 ? (
//                 sampleUtterances.map((utterance, index) => (
//                   <div
//                     key={index}
//                     onClick={() => handleUtteranceClick(utterance)}
//                     className={`px-3 py-1 rounded-full text-xs cursor-pointer shadow-sm ${
//                       selectedUtterance === utterance ? "bg-blue-500 text-white" : "bg-white text-gray-700 hover:bg-blue-100"
//                     } border border-gray-200`}
//                   >
//                     {utterance}
//                   </div>
//                 ))
//               ) : (
//                 <p className="text-xs text-gray-500">{t("No utterances available")}</p>
//               )}
//             </div>
//           </div>
//         </div>

//         {selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && (
//           <div className="mb-4 w-full">
//             <label htmlFor="channel-name" className="flex items-center text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               <span>{t("Channel Name")}</span>
//               <span className="text-red-500 ml-1">*</span>
//             </label>
//             <input
//               id="channel-name"
//               type="text"
//               value={channelName}
//               onChange={(e) => setChannelName(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//               placeholder={t("Enter channel name (e.g., BBC, HBO)")}
//               required
//             />
//           </div>
//         )}

//         <div className="mb-4">
//           <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">{t("Select Audio Input Method")}</label>
//           <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-2 sm:space-y-0">
//             <label className="flex items-center text-xs sm:text-sm">
//               <input type="checkbox" checked={mode === "upload"} onChange={() => handleModeChange("upload")} className="mr-2" />
//               {t("Upload Audio")}
//             </label>
//             <label className="flex items-center text-xs sm:text-sm">
//               <input type="checkbox" checked={mode === "record"} onChange={() => handleModeChange("record")} className="mr-2" />
//               {t("Record Audio")}
//             </label>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           <div className="mb-4 w-full sm:col-span-2">
//             {mode === "upload" ? (
//               <>
//                 <label htmlFor="file-input" className="block text-sm font-medium text-gray-700 mb-1">{t("Upload Audio")}</label>
//                 <div className="flex items-center space-x-4 border border-gray-300 rounded-lg p-2">
//                   <input
//                     ref={fileInputRef}
//                     id="file-input"
//                     type="file"
//                     accept=".mp3,.wav"
//                     onChange={handleFileChange}
//                     className="hidden"
//                   />
//                   <button
//                     onClick={() => fileInputRef.current?.click()}
//                     className="px-4 py-2 border border-blue-500 text-blue-500 rounded-lg hover:bg-blue-500 hover:text-white text-xs sm:text-sm transition"
//                   >
//                     {t("Choose File")}
//                   </button>
//                   <span className="text-sm text-gray-600">
//                     {audioFile ? audioFile.name : t("No file chosen")}
//                   </span>
//                 </div>
//               </>
//             ) : mode === "record" ? (
//               <div className="flex flex-col items-center">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">{t("Record Audio")}</label>
//                 <button
//                   onClick={isRecording ? stopRecording : startRecording}
//                   className={`flex items-center justify-center px-4 py-2 rounded text-white text-sm ${
//                     isRecording ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                   }`}
//                   disabled={isTranscribing}
//                 >
//                   {isRecording ? (
//                     <>
//                       <Loader2 className="w-5 h-5 mr-2 animate-spin" />
//                       {t("Stop")}
//                     </>
//                   ) : (
//                     <>
//                       <Mic className="w-5 h-5 mr-2" />
//                       {t("Start Audio")}
//                     </>
//                   )}
//                 </button>
//               </div>
//             ) : null}
//           </div>
//         </div>

//         {audioPreview && (
//           <div className="mb-4 w-full flex justify-center items-center overflow-hidden rounded-lg border border-gray-300 p-4 relative">
//             <audio controls src={audioPreview} className="w-full max-w-md" />
//             <button
//               onClick={handleDeleteUploadedFile}
//               className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
//             >
//               X
//             </button>
//           </div>
//         )}

//         {isTranscribing && (
//           <div className="flex justify-center items-center mb-4">
//             <div className="loader"></div>
//             <span className="ml-2 text-gray-700">{t("Transcribing")}</span>
//           </div>
//         )}

//         {transcribedText && (
//           <div className="mb-4 space-y-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">{t("AI Transcribed Text")}</label>
//               <p className="p-2 border border-gray-300 rounded-lg bg-gray-50 text-sm">{transcribedText}</p>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">{t("Transcription Status")}</label>
//               <div className="mt-2 flex space-x-4">
//                 <label className="flex items-center text-sm">
//                   <input
//                     type="checkbox"
//                     checked={transcribedStatus === "ok"}
//                     onChange={() => {
//                       setTranscribedStatus(transcribedStatus === "ok" ? null : "ok");
//                       setUserInputText("");
//                     }}
//                     disabled={!transcribedText}
//                     className="mr-2"
//                   />
//                   {t("OK")}
//                 </label>
//                 <label className="flex items-center text-sm">
//                   <input
//                     type="checkbox"
//                     checked={transcribedStatus === "not_ok"}
//                     onChange={() => {
//                       setTranscribedStatus(transcribedStatus === "not_ok" ? null : "not_ok");
//                     }}
//                     disabled={!transcribedText}
//                     className="mr-2"
//                   />
//                   {t("Not OK")}
//                 </label>
//               </div>
//             </div>

//             {transcribedStatus === "not_ok" && (
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   {t("User Input")} <span className="text-red-500">*</span>
//                 </label>
//                 <textarea
//                   value={userInputText}
//                   onChange={(e) => setUserInputText(e.target.value)}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//                   rows="2"
//                   placeholder={t("Enter the correct text here")}
//                   required
//                 />
//               </div>
//             )}
//           </div>
//         )}

//         {translationText && (
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">{t("Translated Text")}</label>
//             <p className="p-2 border border-gray-300 rounded-lg bg-gray-50 text-sm">{translationText}</p>
//           </div>
//         )}

//         <div className="flex flex-col sm:flex-row sm:space-x-6 w-full">
//           <button
//             onClick={handleSave}
//             className={`w-full py-3 rounded-lg mt-4 sm:mt-0 text-xs sm:text-sm text-white ${
//               !audioFile ||
//               !languageCode ||
//               !gender ||
//               !age ||
//               !transcribedText ||
//               !transcribedStatus ||
//               (transcribedStatus === "not_ok" && !userInputText.trim()) ||
//               !uploaderEmail ||
//               isTranscribing ||
//               (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim())
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-green-500 hover:bg-green-600"
//             }`}
//             disabled={
//               !audioFile ||
//               !languageCode ||
//               !gender ||
//               !age ||
//               !transcribedText ||
//               !transcribedStatus ||
//               (transcribedStatus === "not_ok" && !userInputText.trim()) ||
//               isTranscribing ||
//               (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim())
//             }
//           >
//             {t("Upload")}
//           </button>
//           <button
//             onClick={fetchAudioDetails}
//             className="w-full bg-blue-500 text-white py-3 rounded-lg mt-4 sm:mt-0 hover:bg-blue-600 text-xs sm:text-sm"
//           >
//             {t("Uploaded Audios")}
//           </button>
//         </div>
//         {showUploadedAudios && (
//   <div className="mt-6 relative">
//     {isFetchingAudios ? (
//       <div className="flex justify-center items-center h-64">
//         <div className="loader"></div>
//       </div>
//     ) : (
//       <>
//         <h2 className="text-xl font-semibold text-gray-800 mb-4">{t("Uploaded Audios")}</h2>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Filter by Language")}</label>
//             <select
//               value={filterLanguage}
//               onChange={(e) => setFilterLanguage(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("All Languages")}</option>
//               {uniqueLanguages.map((lang) => (
//                 <option key={lang} value={lang}>
//                   {lang === "english" ? "English" :
//                    lang === "portuguese" ? "Português" :
//                    lang === "spanish" ? "Español" :
//                    lang === "spanish_ar" ? "Español (AR)" :
//                    lang === "spanish_mx" ? "Español (MX)" :
//                    lang === "spanish_cl" ? "Español (CL)" :
//                    lang === "spanish_pe" ? "Español (PE)" :
//                    lang === "french" ? "Français" :
//                    lang === "german" ? "Deutsch" :
//                    lang === "italian" ? "Italiano" :
//                    lang === "chinese_tw" ? "中文 (繁體, 台灣)" :
//                    lang === "chinese_cn" ? "中文 (简体, 中国)" :
//                    lang === "chinese_sg" ? "中文 (简体, 新加坡)" :
//                    lang === "dutch_be" ? "Nederlands (BE)" :
//                    lang === "dutch_nl" ? "Nederlands (NL)" : lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Filter by Voice Control")}</label>
//             <select
//               value={filterVoiceControl}
//               onChange={(e) => setFilterVoiceControl(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("All Voice Controls")}</option>
//               {uniqueVoiceControls.map((control) => (
//                 <option key={control} value={control}>{control}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="flex flex-col sm:flex-row sm:space-x-4 mb-4 items-start sm:items-center">
//           <button
//             onClick={prepareZip}
//             className={`w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm ${
//               selectedFiles.length === 0 || isPreparingZip
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-purple-500 hover:bg-purple-600"
//             }`}
//             disabled={selectedFiles.length === 0 || isPreparingZip}
//           >
//             {isPreparingZip ? (
//               <>
//                 <Loader2 className="w-5 h-5 mr-2 inline-block animate-spin" />
//                 {t("Preparing ZIP...")}
//               </>
//             ) : (
//               t("Get ZIP")
//             )}
//           </button>

//           {zipDownloadUrl && (
//             <button
//               onClick={handleZipDownload}
//               className="w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm bg-blue-500 hover:bg-blue-600"
//             >
//               {t("Download ZIP")}
//             </button>
//           )}

//           <div className="flex items-center mt-2 sm:mt-0 sm:ml-4">
//             <input
//               type="checkbox"
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//               className="mr-2 h-4 w-4 text-blue-600"
//             />
//             <label className="text-sm text-gray-700">{t("Select All")}</label>
//           </div>
//         </div>

//         <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg bg-gray-50 p-4">
//           {filteredAudioDetails.length > 0 ? (
//             filteredAudioDetails.map((audio) => (
//               <div
//                 key={audio._id}
//                 className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 mb-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
//               >
//                 <div className="flex items-center flex-1 mb-2 sm:mb-0 space-y-1">
//                   <input
//                     type="checkbox"
//                     checked={selectedFiles.includes(audio.fileName)}
//                     onChange={() => handleFileSelect(audio.fileName)}
//                     className="mr-2 h-4 w-4 text-blue-600"
//                   />
//                   <div>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Language")}:</strong> {audio.audioLanguage} ({audio.languageCode})
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Voice Control")}:</strong> {audio.audiotext}
//                     </p>
//                     {/* Conditionally display ChannelName only when audiotext is "Change Channel by Name" */}
//                     {audio.audiotext === "Change Channel by Name" && (
//                       <p className="text-xs sm:text-sm text-gray-700">
//                         <strong>{t("Channel Name")}:</strong> {audio.ChannelName || "N/A"}
//                       </p>
//                     )}
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Gender & Age")}:</strong> {audio.audioLabel}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700 truncate">
//                       <strong>{t("AI Transcribed Text")}:</strong> {audio.transcribedText}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700 truncate">
//                       <strong>{t("User Input Text")}:</strong> {audio.userInput || "N/A"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Translated Text")}:</strong> {audio.translation || "NA"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Transcription Status")}:</strong>{" "}
//                       <span className={audio.transcribedStatus === "ok" ? "text-green-600" : "text-red-600"}>
//                         {audio.transcribedStatus === "ok" ? "OK" : "Not OK"}
//                       </span>
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Uploader Email")}:</strong> {audio.uploaderEmail || "N/A"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Upload Date")}:</strong> {new Date(audio.uploadDate).toLocaleString()}
//                     </p>
//                     <p className="text-sm text-gray-700 break-all">
//                       <strong>{t("File Name")}:</strong> {audio.fileName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   {loading[audio._id] ? (
//                     <div className="loader"></div>
//                   ) : (
//                     <button
//                       onClick={() => toggleAudio(audio.fileName, audio._id)}
//                       className={`px-2 py-1 sm:px-3 sm:py-1 rounded text-white text-xs sm:text-sm ${
//                         playing[audio._id] ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                       }`}
//                     >
//                       {playing[audio._id] ? t("Stop") : t("Play")}
//                     </button>
//                   )}
//                   <button
//                     onClick={() => handleDownload(audio.fileName)}
//                     className="px-2 py-1 sm:px-3 sm:py-1 rounded bg-blue-500 text-white text-xs sm:text-sm hover:bg-blue-600"
//                   >
//                     {t("Download")}
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p className="text-sm text-gray-500">{t("No audio files match the selected filters.")}</p>
//           )}
//         </div>
//       </>
//     )}
//   </div>
// )}
//       </div>
//     </div>
//   );
// }

// export default Audiopage;

//prefiled
// import React, { useState, useRef, useEffect } from "react";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { Mic, MicOff, Loader2 } from "lucide-react";
// import axios from "axios";
// import { decodedToken } from "./utils";
// import { tvControlData, translations as tvTranslations } from "../data/tvControlData";
// import { useLanguage } from "../language/LanguageContext";
// import "./App.css";

// // Function to resample audio buffer to 16kHz
// const resampleAudio = async (audioBuffer, targetSampleRate = 16000) => {
//   const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//   const sourceSampleRate = audioBuffer.sampleRate;

//   if (sourceSampleRate === targetSampleRate) {
//     return audioBuffer; // No resampling needed
//   }

//   const offlineContext = new OfflineAudioContext(
//     audioBuffer.numberOfChannels,
//     (audioBuffer.length * targetSampleRate) / sourceSampleRate,
//     targetSampleRate
//   );

//   const bufferSource = offlineContext.createBufferSource();
//   bufferSource.buffer = audioBuffer;
//   bufferSource.connect(offlineContext.destination);
//   bufferSource.start(0);

//   const resampledBuffer = await offlineContext.startRendering();
//   return resampledBuffer;
// };

// // Function to convert AudioBuffer to WAV Blob
// const audioBufferToWavBlob = (audioBuffer) => {
//   const numChannels = audioBuffer.numberOfChannels;
//   const sampleRate = audioBuffer.sampleRate;
//   const length = audioBuffer.length * numChannels * 2 + 44;
//   const buffer = new ArrayBuffer(length);
//   const view = new DataView(buffer);

//   let offset = 0;

//   // Write WAV header
//   const writeString = (str) => {
//     for (let i = 0; i < str.length; i++) {
//       view.setUint8(offset++, str.charCodeAt(i));
//     }
//   };

//   writeString("RIFF");
//   view.setUint32(4, 36 + audioBuffer.length * numChannels * 2, true);
//   writeString("WAVE");
//   writeString("fmt ");
//   view.setUint32(offset, 16, true); // Sub-chunk size
//   offset += 4;
//   view.setUint16(offset, 1, true); // Audio format (PCM)
//   offset += 2;
//   view.setUint16(offset, numChannels, true); // Number of channels
//   offset += 2;
//   view.setUint32(offset, sampleRate, true); // Sample rate
//   offset += 4;
//   view.setUint32(offset, sampleRate * numChannels * 2, true); // Byte rate
//   offset += 4;
//   view.setUint16(offset, numChannels * 2, true); // Block align
//   offset += 2;
//   view.setUint16(offset, 16, true); // Bits per sample
//   offset += 2;
//   writeString("data");
//   view.setUint32(offset, audioBuffer.length * numChannels * 2, true);
//   offset += 4;

//   // Write interleaved samples
//   for (let i = 0; i < audioBuffer.length; i++) {
//     for (let channel = 0; channel < numChannels; channel++) {
//       const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
//       view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
//       offset += 2;
//     }
//   }

//   return new Blob([buffer], { type: "audio/wav" });
// };

// function Audiopage() {
//   const navigate = useNavigate();
//   const { language, setLanguage, t } = useLanguage();
//   const [audioFile, setAudioFile] = useState(null);
//   const [uploadaudioFile, setUploadAudioFile] = useState(null);
//   const [audioPreview, setAudioPreview] = useState(null);
//   const [languageCode, setLanguageCode] = useState("en");
//   const [gender, setGender] = useState("");
//   const [audioDetails, setAudioDetails] = useState([]);
//   const [age, setAge] = useState("");
//   const [audiotext, setAudiotext] = useState("");
//   const [userInputText, setUserInputText] = useState("");
//   const [transcribedText, setTranscribedText] = useState("");
//   const [translationText, settranslationText] = useState("");
//   const [editableTranscribedText, setEditableTranscribedText] = useState("");
//   const [loading, setLoading] = useState({});
//   const [transcribedStatus, setTranscribedStatus] = useState(null);
//   const [isTranscribing, setIsTranscribing] = useState(false);
//   const [audioBuffers, setAudioBuffers] = useState({});
//   const [activeAudio, setActiveAudio] = useState(null);
//   const [playing, setPlaying] = useState({});
//   const [mode, setMode] = useState("record");
//   const [isRecording, setIsRecording] = useState(false);
//   const [uploaderEmail, setUploaderEmail] = useState("");
//   const fileInputRef = useRef();
//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);
//   const ServerUrl = "https://voice-sample.tpvai.com/b/";

//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedVoiceControl, setSelectedVoiceControl] = useState("");
//   const [sampleUtterances, setSampleUtterances] = useState([]);
//   const [selectedUtterance, setSelectedUtterance] = useState("");
//   const [voiceControlOptions, setVoiceControlOptions] = useState([]);
//   const [channelName, setChannelName] = useState("");

//   const [zipFileName, setZipFileName] = useState("");
//   const [showUploadedAudios, setShowUploadedAudios] = useState(false);
//   const [filterLanguage, setFilterLanguage] = useState("");
//   const [filterVoiceControl, setFilterVoiceControl] = useState("");
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [zipDownloadUrl, setZipDownloadUrl] = useState("");
//   const [isPreparingZip, setIsPreparingZip] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [isFetchingAudios, setIsFetchingAudios] = useState(false);

//   const decode = decodedToken();
//   const isAdmin = decode?.role === "admin";
//   const emailUser = localStorage.getItem("email");

//   const languageMap = {
//     english: "en",
//     portuguese: "pt",
//     spanish: "es",
//     spanish_ar: "es-ar",
//     spanish_mx: "es_mx",
//     spanish_cl: "es-cl",
//     spanish_pe: "es-pe",
//     french: "fr",
//     german: "de",
//     italian: "it",
//     chinese_tw: "zh-TW",
//     chinese_cn: "zh-CN",
//     chinese_sg: "zh-SG",
//     dutch_be: "nl-BE",
//     dutch_nl: "nl-NL",
//   };

//   const getTranscriptionLanguageCode = (code) => {
//     if (["es", "es-ar", "es_mx", "es-cl", "es-pe"].includes(code)) return "es";
//     if (["zh-TW", "zh-CN", "zh-SG"].includes(code)) return "zh";
//     if (["nl-BE", "nl-NL"].includes(code)) return "nl";
//     const transcriptionMap = {
//       en: "en",
//       pt: "pt",
//       fr: "fr",
//       de: "de",
//       it: "it",
//     };
//     return transcriptionMap[code] || "en";
//   };

//   const categories = Object.keys(tvControlData);

//   // Load saved user details from localStorage on component mount
//   useEffect(() => {
//     const savedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
//     if (savedUserDetails) {
//       setLanguageCode(savedUserDetails.languageCode || "en");
//       setLanguage(savedUserDetails.languageCode || "en");
//       setGender(savedUserDetails.gender || "");
//       setAge(savedUserDetails.age || "");
//       setUploaderEmail(savedUserDetails.uploaderEmail || "");
//     }
//   }, []);

//   useEffect(() => {
//     if (selectedCategory && tvControlData[selectedCategory]) {
//       setVoiceControlOptions(Object.keys(tvControlData[selectedCategory]));
//       setSelectedVoiceControl("");
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when category changes
//     } else {
//       setVoiceControlOptions([]);
//       setSelectedVoiceControl("");
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when category is cleared
//     }
//   }, [selectedCategory]);

//   useEffect(() => {
//     if (selectedCategory && selectedVoiceControl && tvControlData[selectedCategory][selectedVoiceControl]) {
//       const langKey =
//         language === "en" ? "english" :
//         language === "pt" ? "portuguese" :
//         language === "es" ? "spanish" :
//         language === "es-ar" ? "spanish_ar" :
//         language === "es_mx" ? "spanish_mx" :
//         language === "es-cl" ? "spanish_cl" :
//         language === "es-pe" ? "spanish_pe" :
//         language === "fr" ? "french" :
//         language === "de" ? "german" :
//         language === "it" ? "italian" :
//         language === "zh-TW" ? "chinese_tw" :
//         language === "zh-CN" ? "chinese_cn" :
//         language === "zh-SG" ? "chinese_sg" :
//         language === "nl-BE" ? "dutch_be" :
//         language === "nl-NL" ? "dutch_nl" : "english";
//       const utterances = tvControlData[selectedCategory][selectedVoiceControl][langKey] || tvControlData[selectedCategory][selectedVoiceControl]["english"];
//       setSampleUtterances(utterances || []);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when voice control changes
//     } else {
//       setSampleUtterances([]);
//       setSelectedUtterance("");
//       setAudiotext("");
//       setChannelName(""); // Clear channel name when voice control is cleared
//     }
//   }, [selectedCategory, selectedVoiceControl, language]);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("userDetails"); // Clear user details on logout
//     navigate("/");
//   };

//   const handleAdminPage = () => {
//     navigate("/admin");
//   };

//   const handleFileSelect = (fileName) => {
//     let updatedSelection;
//     if (selectedFiles.includes(fileName)) {
//       updatedSelection = selectedFiles.filter((file) => file !== fileName);
//     } else {
//       updatedSelection = [...selectedFiles, fileName];
//     }
//     setSelectedFiles(updatedSelection);
//     setIsAllSelected(updatedSelection.length === filteredAudioDetails.length);
//   };

//   const handleSelectAll = () => {
//     if (isAllSelected) {
//       setSelectedFiles([]);
//       setIsAllSelected(false);
//     } else {
//       const allFileNames = filteredAudioDetails.map((audio) => audio.fileName);
//       setSelectedFiles(allFileNames);
//       setIsAllSelected(true);
//     }
//   };

//   const handleLanguageChange = (e) => {
//     const selectedLanguage = e.target.value;
//     let newLanguage;
//     switch (selectedLanguage) {
//       case "english": newLanguage = "en"; break;
//       case "portuguese": newLanguage = "pt"; break;
//       case "spanish": newLanguage = "es"; break;
//       case "spanish_ar": newLanguage = "es-ar"; break;
//       case "spanish_mx": newLanguage = "es_mx"; break;
//       case "spanish_cl": newLanguage = "es-cl"; break;
//       case "spanish_pe": newLanguage = "es-pe"; break;
//       case "french": newLanguage = "fr"; break;
//       case "german": newLanguage = "de"; break;
//       case "italian": newLanguage = "it"; break;
//       case "chinese_tw": newLanguage = "zh-TW"; break;
//       case "chinese_cn": newLanguage = "zh-CN"; break;
//       case "chinese_sg": newLanguage = "zh-SG"; break;
//       case "dutch_be": newLanguage = "nl-BE"; break;
//       case "dutch_nl": newLanguage = "nl-NL"; break;
//       default: newLanguage = "en";
//     }
//     setLanguage(newLanguage);
//     const langKey = selectedLanguage;
//     setLanguageCode(languageMap[langKey] || "");
//     setSelectedCategory("");
//     setSelectedVoiceControl("");
//     setSampleUtterances([]);
//     setSelectedUtterance("");
//     setAudiotext("");
//     setChannelName(""); // Clear channel name when language changes
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//     setChannelName("");
//   };

//   const handleVoiceControlChange = (e) => {
//     setSelectedVoiceControl(e.target.value);
//     setChannelName("");
//   };

//   const handleUtteranceClick = (utterance) => {
//     setSelectedUtterance(utterance);
//     setAudiotext(utterance);
//     setChannelName("");
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 10 * 1024 * 1024) {
//         alert("File size should be 10MB or less.");
//         return;
//       }
//       const fileExtension = file.name.split(".").pop();
//       if (fileExtension !== "mp3" && fileExtension !== "wav") {
//         alert("Only .mp3 or .wav files are allowed.");
//         return;
//       }

//       try {
//         const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//         const arrayBuffer = await file.arrayBuffer();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//         const resampledBuffer = await resampleAudio(audioBuffer, 16000);
//         const resampledBlob = audioBufferToWavBlob(resampledBuffer);
//         const resampledFile = new File([resampledBlob], file.name.replace(/\.[^.]+$/, ".wav"), { type: "audio/wav" });

//         setAudioFile(resampledFile);
//         setUploadAudioFile(file);
//         setAudioPreview(URL.createObjectURL(file));
//         setTranscribedText("");
//         settranslationText("");
//         setEditableTranscribedText("");
//         setTranscribedStatus(null);

//         if (languageCode) await transcribeAudio(resampledFile);
//         else Swal.fire("Warning", t("Please select a language before uploading an audio file."), "warning");
//       } catch (error) {
//         Swal.fire("Error", t("Failed to process audio file: ") + error.message, "error");
//       }
//     }
//   };

//   const startRecording = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       mediaRecorderRef.current = new MediaRecorder(stream);
//       audioChunksRef.current = [];
//       mediaRecorderRef.current.ondataavailable = (event) => audioChunksRef.current.push(event.data);
//       mediaRecorderRef.current.onstop = async () => {
//         const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
//         const audioFileUpload = new File([audioBlob], "recorded-audio.wav", { type: "audio/wav" });
//         const arrayBuffer = await audioBlob.arrayBuffer();
//         const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//         const resampledBuffer = await resampleAudio(audioBuffer, 16000);
//         const resampledBlob = audioBufferToWavBlob(resampledBuffer);
//         const audioFile = new File([resampledBlob], "recorded-audio.wav", { type: "audio/wav" });

//         setAudioFile(audioFile);
//         setUploadAudioFile(audioFileUpload);
//         setAudioPreview(URL.createObjectURL(audioBlob));
//         setTranscribedText("");
//         settranslationText("");
//         setEditableTranscribedText("");
//         setTranscribedStatus(null);
//         stream.getTracks().forEach((track) => track.stop());

//         if (languageCode) await transcribeAudio(audioFile);
//         else Swal.fire("Warning", t("Please select a language before recording audio."), "warning");
//       };
//       mediaRecorderRef.current.start();
//       setIsRecording(true);
//     } catch (error) {
//       Swal.fire("Error", t("Failed to access microphone: ") + error.message, "error");
//     }
//   };

//   const stopRecording = () => {
//     if (mediaRecorderRef.current && isRecording) {
//       mediaRecorderRef.current.stop();
//       setIsRecording(false);
//     }
//   };

//   const transcribeAudio = async (file) => {
//     setIsTranscribing(true);
//     setUserInputText("");
//     const formData = new FormData();
//     formData.append("audio", file);
//     formData.append("language", getTranscriptionLanguageCode(languageCode));
//     try {
//       const response = await axios.post(`${ServerUrl}api/stt/upload-audio`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if (response.status === 200) {
//         setTranscribedText(response.data.transcribedText.transcription);
//         settranslationText(response.data.transcribedText.translation);
//         setEditableTranscribedText(response.data.transcribedText.transcription);
//       }
//     } catch (error) {
//       Swal.fire("Error", error.response?.data?.message || t("Failed to transcribe audio"), "error");
//     } finally {
//       setIsTranscribing(false);
//     }
//   };

//   const toggleAudio = async (fileName, audioId) => {
//     if (activeAudio && activeAudio.id !== audioId && activeAudio.instance) {
//       activeAudio.instance.pause();
//       activeAudio.instance.currentTime = 0;
//       setPlaying((prev) => ({ ...prev, [activeAudio.id]: false }));
//     }
//     if (!audioBuffers[audioId]) {
//       setLoading((prev) => ({ ...prev, [audioId]: true }));
//       try {
//         const response = await axios.post(`${ServerUrl}stream_audio`, { file: fileName }, { responseType: "blob" });
//         const audioBlob = new Blob([response.data], { type: "audio/mpeg" });
//         const audioUrl = URL.createObjectURL(audioBlob);
//         const audio = new Audio(audioUrl);
//         setAudioBuffers((prev) => ({ ...prev, [audioId]: audioUrl }));
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play();
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       } catch (error) {
//         Swal.fire("Error", t("Failed to load audio: ") + error.message, "error");
//       } finally {
//         setLoading((prev) => ({ ...prev, [audioId]: false }));
//       }
//     } else {
//       const audio = activeAudio?.id === audioId ? activeAudio.instance : new Audio(audioBuffers[audioId]);
//       const isPlaying = playing[audioId];
//       if (isPlaying) {
//         audio.pause();
//         audio.currentTime = 0;
//         setPlaying((prev) => ({ ...prev, [audioId]: false }));
//         setActiveAudio(null);
//       } else {
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play().catch((err) => console.error("Play error:", err));
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       }
//     }
//   };

//   const handleDownload = async (fileName) => {
//     try {
//       const response = await axios.get(`${ServerUrl}download_audio?file=${encodeURIComponent(fileName)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       Swal.fire("Error", t("Failed to download audio: ") + error.message, "error");
//     }
//   };

//   const handleSave = async () => {
//     if (!audioFile || !languageCode || !gender || !age || !transcribedText || !transcribedStatus || !selectedVoiceControl || !uploaderEmail) {
//       Swal.fire("Error", t("Please fill in all fields, including uploader email, upload or record an audio file, and verify transcription."), "error");
//       return;
//     }

//     if (transcribedStatus === "not_ok" && !userInputText.trim()) {
//       Swal.fire("Error", t("Please provide the user input when transcription is Not OK."), "error");
//       return;
//     }

//     if (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim()) {
//       Swal.fire("Error", t("Please enter a channel name."), "error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("audio", uploadaudioFile);
//     formData.append("email", emailUser);
//     formData.append("uploaderEmail", uploaderEmail);
//     formData.append("audiotext", selectedVoiceControl || "na");
//     formData.append("audioLabel", `${gender} - ${age}`);
//     formData.append("audioLanguage",
//       language === "en" ? "english" :
//       language === "pt" ? "portuguese" :
//       language === "es" ? "spanish" :
//       language === "es-ar" ? "spanish_ar" :
//       language === "es_mx" ? "spanish_mx" :
//       language === "es-cl" ? "spanish_cl" :
//       language === "es-pe" ? "spanish_pe" :
//       language === "fr" ? "french" :
//       language === "de" ? "german" :
//       language === "it" ? "italian" :
//       language === "zh-TW" ? "chinese_tw" :
//       language === "zh-CN" ? "chinese_cn" :
//       language === "zh-SG" ? "chinese_sg" :
//       language === "nl-BE" ? "dutch_be" :
//       language === "nl-NL" ? "dutch_nl" : "");
//     formData.append("languageCode", language);
//     formData.append("transcribedText", transcribedText);
//     formData.append("userInputText", transcribedStatus === "ok" ? "" : userInputText);
//     formData.append("transcribedStatus", transcribedStatus);
//     formData.append("translation", translationText);
//     formData.append("ChannelName", selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" ? channelName : "na");
//     try {
//       const response = await axios.post(`${ServerUrl}uploads`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if (response.status === 200 || response.status === 201) {
//         // Save user details to localStorage
//         const userDetails = {
//           languageCode,
//           gender,
//           age,
//           uploaderEmail,
//         };
//         localStorage.setItem("userDetails", JSON.stringify(userDetails));

//         Swal.fire("Success", t("Audio successfully uploaded!"), "success");
//         handleDeleteUploadedFile();
//         setChannelName("");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || t("Something went wrong"), "error");
//     }
//   };

//   const handleDeleteUploadedFile = () => {
//     if (audioPreview) URL.revokeObjectURL(audioPreview);
//     setAudioFile(null);
//     setUploadAudioFile(null);
//     setAudioPreview(null);
//     setAudiotext("");
//     setTranscribedText("");
//     settranslationText("");
//     setEditableTranscribedText("");
//     setUserInputText("");
//     setTranscribedStatus(null);
//     setSelectedCategory("");
//     setSelectedVoiceControl("");
//     setSelectedUtterance("");
//     setChannelName("");
//     setIsRecording(false);
//     if (mode === "upload" && fileInputRef.current) fileInputRef.current.value = null;
//   };

//   const fetchAudioDetails = async () => {
//     setIsFetchingAudios(true);
//     setShowUploadedAudios(true);
//     try {
//       const response = await axios.get(`${ServerUrl}audios?email=${emailUser}`);
//       if (response.status === 200) {
//         const sortedData = response.data.data.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
//         setAudioDetails(sortedData);
//       } else {
//         throw new Error(t("Failed to fetch audio details"));
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || t("Failed to fetch audio details"), "error");
//     } finally {
//       setIsFetchingAudios(false);
//     }
//   };

//   const getTranslatedText = (key, type) => {
//     const langKey =
//       language === "en" ? "english" :
//       language === "pt" ? "portuguese" :
//       language === "es" ? "spanish" :
//       language === "es-ar" ? "spanish_ar" :
//       language === "es_mx" ? "spanish_mx" :
//       language === "es-cl" ? "spanish_cl" :
//       language === "es-pe" ? "spanish_pe" :
//       language === "fr" ? "french" :
//       language === "de" ? "german" :
//       language === "it" ? "italian" :
//       language === "zh-TW" ? "chinese_tw" :
//       language === "zh-CN" ? "chinese_cn" :
//       language === "zh-SG" ? "chinese_sg" :
//       language === "nl-BE" ? "dutch_be" :
//       language === "nl-NL" ? "dutch_nl" : "english";
//     const translationMap = type === "category" ? tvTranslations.categories : tvTranslations.voiceControls;
//     return translationMap[key]?.[langKey] || translationMap[key]?.["english"] || key;
//   };

//   const handleModeChange = (newMode) => setMode(mode === newMode ? "" : newMode);

//   const prepareZip = async () => {
//     if (selectedFiles.length === 0) {
//       Swal.fire("Warning", t("Please select at least one audio file to download as ZIP."), "warning");
//       return;
//     }
//     setIsPreparingZip(true);
//     try {
//       const response = await axios.post(`${ServerUrl}prepare_audio_zip`, {
//         files: selectedFiles,
//         filterVoiceControl: filterVoiceControl,
//         filterLanguage: filterLanguage,
//       });
//       if (response.status === 200) {
//         setZipDownloadUrl(response.data.downloadUrl);
//         Swal.fire("Success", t("ZIP file prepared successfully!"), "success");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.response?.data?.message || t("Failed to prepare ZIP file"), "error");
//     } finally {
//       setIsPreparingZip(false);
//     }
//   };

//   const handleZipDownload = () => {
//     if (zipDownloadUrl) {
//       const link = document.createElement("a");
//       link.href = zipDownloadUrl;
//       link.setAttribute("download", "");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       setZipDownloadUrl("");
//       setSelectedFiles([]);
//     }
//   };

//   const filteredAudioDetails = audioDetails
//     .filter((audio) => {
//       const matchesLanguage = filterLanguage ? audio.audioLanguage === filterLanguage : true;
//       const matchesVoiceControl = filterVoiceControl ? audio.audiotext === filterVoiceControl : true;
//       return matchesLanguage && matchesVoiceControl;
//     })
//     .sort((a, b) => {
//       const langCompare = a.audioLanguage.localeCompare(b.audioLanguage);
//       if (langCompare !== 0) return langCompare;
//       return a.audiotext.localeCompare(b.audiotext);
//     });

//   const uniqueLanguages = [...new Set(audioDetails.map((audio) => audio.audioLanguage))].sort((a, b) =>
//     a.localeCompare(b)
//   );
//   const uniqueVoiceControls = [...new Set(audioDetails.map((audio) => audio.audiotext))].sort((a, b) =>
//     a.localeCompare(b)
//   );

//   return (
//     <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex flex-col justify-start items-center p-4 pt-10 pb-10 overflow-y-auto scroll-mt-32">
//       <div className="bg-white p-6 sm:p-8 md:p-10 rounded-xl shadow-xl space-y-6 w-full max-w-5xl">
//         <h1 className="text-2xl sm:text-3xl font-semibold text-center mb-6 text-gray-800">{t("Audio File Upload")}</h1>
//         <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
//           <button onClick={handleLogout} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
//             {t("Logout")}
//           </button>
//           {isAdmin && (
//             <button onClick={handleAdminPage} className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600">
//               {t("Admin Page")}
//             </button>
//           )}
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           <div className="mb-4 w-full">
//             <label htmlFor="language-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               {t("Select Language")}
//             </label>
//             <select
//               id="language-select"
//               value={
//                 language === "en" ? "english" :
//                 language === "pt" ? "portuguese" :
//                 language === "es" ? "spanish" :
//                 language === "es-ar" ? "spanish_ar" :
//                 language === "es_mx" ? "spanish_mx" :
//                 language === "es-cl" ? "spanish_cl" :
//                 language === "es-pe" ? "spanish_pe" :
//                 language === "fr" ? "french" :
//                 language === "de" ? "german" :
//                 language === "it" ? "italian" :
//                 language === "zh-TW" ? "chinese_tw" :
//                 language === "zh-CN" ? "chinese_cn" :
//                 language === "zh-SG" ? "chinese_sg" :
//                 language === "nl-BE" ? "dutch_be" :
//                 language === "nl-NL" ? "dutch_nl" : ""
//               }
//               onChange={handleLanguageChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Language")}</option>
//               <option value="english">English (EN)</option>
//               <option value="portuguese">Português (PT)</option>
//               <option value="spanish">Español (ES)</option>
//               <option value="spanish_ar">Español (AR)</option>
//               <option value="spanish_mx">Español (MX)</option>
//               <option value="spanish_cl">Español (CL)</option>
//               <option value="spanish_pe">Español (PE)</option>
//               <option value="french">Français (FR)</option>
//               <option value="german">Deutsch (DE)</option>
//               <option value="italian">Italiano (IT)</option>
//               <option value="chinese_tw">中文 (繁體, 台灣)</option>
//               <option value="chinese_cn">中文 (简体, 中国)</option>
//               <option value="chinese_sg">中文 (简体, 新加坡)</option>
//               <option value="dutch_be">Nederlands (BE)</option>
//               <option value="dutch_nl">Nederlands (NL)</option>
//             </select>
//           </div>

//           <div className="mb-4 w-full">
//             <label htmlFor="gender-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               {t("Select Gender")}
//             </label>
//             <select
//               id="gender-select"
//               value={gender}
//               onChange={(e) => { setGender(e.target.value); setAge(""); }}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Gender")}</option>
//               <option value="Female">{t("Female")}</option>
//               <option value="Male">{t("Male")}</option>
//             </select>
//           </div>

//           <div className="mb-4 w-full sm:col-span-2">
//             <label htmlFor="uploader-email" className="flex items-center text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               <span>{t("Uploader Email")}</span>
//               <span className="text-red-500 ml-1"></span>
//             </label>
//             <input
//               id="uploader-email"
//               type="email"
//               value={uploaderEmail}
//               onChange={(e) => setUploaderEmail(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm box-border"
//               placeholder={t("Enter uploader email")}
//               required
//             />
//           </div>

//           {gender && (
//             <div className="mb-4 w-full sm:col-span-2">
//               <label htmlFor="age-select" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//                 {t("Select Age Category")}
//               </label>
//               <select
//                 id="age-select"
//                 value={age}
//                 onChange={(e) => setAge(e.target.value)}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//               >
//                 <option value="">{t("Select Age Category")}</option>
//                 <option value="Kid">{t("Kid")}</option>
//                 <option value="Adult">{t("Adult")}</option>
//                 <option value="Older">{t("Older")}</option>
//               </select>
//             </div>
//           )}
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Category")}</label>
//             <select
//               value={selectedCategory}
//               onChange={handleCategoryChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Category")}</option>
//               {categories.map((category) => (
//                 <option key={category} value={category}>{getTranslatedText(category, "category")}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Voice Control")}</label>
//             <select
//               value={selectedVoiceControl}
//               onChange={handleVoiceControlChange}
//               disabled={!selectedCategory}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("Select Voice Control")}</option>
//               {voiceControlOptions.map((option) => (
//                 <option key={option} value={option}>{getTranslatedText(option, "voiceControl")}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Sample Utterances")}</label>
//             <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg bg-gray-50 max-h-32 overflow-y-auto">
//               {sampleUtterances.length > 0 ? (
//                 sampleUtterances.map((utterance, index) => (
//                   <div
//                     key={index}
//                     onClick={() => handleUtteranceClick(utterance)}
//                     className={`px-3 py-1 rounded-full text-xs cursor-pointer shadow-sm ${
//                       selectedUtterance === utterance ? "bg-blue-500 text-white" : "bg-white text-gray-700 hover:bg-blue-100"
//                     } border border-gray-200`}
//                   >
//                     {utterance}
//                   </div>
//                 ))
//               ) : (
//                 <p className="text-xs text-gray-500">{t("No utterances available")}</p>
//               )}
//             </div>
//           </div>
//         </div>

//         {selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && (
//           <div className="mb-4 w-full">
//             <label htmlFor="channel-name" className="flex items-center text-xs sm:text-sm font-medium text-gray-700 mb-1">
//               <span>{t("Channel Name")}</span>
//               <span className="text-red-500 ml-1">*</span>
//             </label>
//             <input
//               id="channel-name"
//               type="text"
//               value={channelName}
//               onChange={(e) => setChannelName(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//               placeholder={t("Enter channel name (e.g., BBC, HBO)")}
//               required
//             />
//           </div>
//         )}

//         <div className="mb-4">
//           <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">{t("Select Audio Input Method")}</label>
//           <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-2 sm:space-y-0">
//             <label className="flex items-center text-xs sm:text-sm">
//               <input type="checkbox" checked={mode === "upload"} onChange={() => handleModeChange("upload")} className="mr-2" />
//               {t("Upload Audio")}
//             </label>
//             <label className="flex items-center text-xs sm:text-sm">
//               <input type="checkbox" checked={mode === "record"} onChange={() => handleModeChange("record")} className="mr-2" />
//               {t("Record Audio")}
//             </label>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           <div className="mb-4 w-full sm:col-span-2">
//             {mode === "upload" ? (
//               <>
//                 <label htmlFor="file-input" className="block text-sm font-medium text-gray-700 mb-1">{t("Upload Audio")}</label>
//                 <div className="flex items-center space-x-4 border border-gray-300 rounded-lg p-2">
//                   <input
//                     ref={fileInputRef}
//                     id="file-input"
//                     type="file"
//                     accept=".mp3,.wav"
//                     onChange={handleFileChange}
//                     className="hidden"
//                   />
//                   <button
//                     onClick={() => fileInputRef.current?.click()}
//                     className="px-4 py-2 border border-blue-500 text-blue-500 rounded-lg hover:bg-blue-500 hover:text-white text-xs sm:text-sm transition"
//                   >
//                     {t("Choose File")}
//                   </button>
//                   <span className="text-sm text-gray-600">
//                     {audioFile ? audioFile.name : t("No file chosen")}
//                   </span>
//                 </div>
//               </>
//             ) : mode === "record" ? (
//               <div className="flex flex-col items-center">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">{t("Record Audio")}</label>
//                 <button
//                   onClick={isRecording ? stopRecording : startRecording}
//                   className={`flex items-center justify-center px-4 py-2 rounded text-white text-sm ${
//                     isRecording ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                   }`}
//                   disabled={isTranscribing}
//                 >
//                   {isRecording ? (
//                     <>
//                       <Loader2 className="w-5 h-5 mr-2 animate-spin" />
//                       {t("Stop")}
//                     </>
//                   ) : (
//                     <>
//                       <Mic className="w-5 h-5 mr-2" />
//                       {t("Start Audio")}
//                     </>
//                   )}
//                 </button>
//               </div>
//             ) : null}
//           </div>
//         </div>

//         {audioPreview && (
//           <div className="mb-4 w-full flex justify-center items-center overflow-hidden rounded-lg border border-gray-300 p-4 relative">
//             <audio controls src={audioPreview} className="w-full max-w-md" />
//             <button
//               onClick={handleDeleteUploadedFile}
//               className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
//             >
//               X
//             </button>
//           </div>
//         )}

//         {isTranscribing && (
//           <div className="flex justify-center items-center mb-4">
//             <div className="loader"></div>
//             <span className="ml-2 text-gray-700">{t("Transcribing")}</span>
//           </div>
//         )}

//         {transcribedText && (
//           <div className="mb-4 space-y-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">{t("AI Transcribed Text")}</label>
//               <p className="p-2 border border-gray-300 rounded-lg bg-gray-50 text-sm">{transcribedText}</p>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">{t("Transcription Status")}</label>
//               <div className="mt-2 flex space-x-4">
//                 <label className="flex items-center text-sm">
//                   <input
//                     type="checkbox"
//                     checked={transcribedStatus === "ok"}
//                     onChange={() => {
//                       setTranscribedStatus(transcribedStatus === "ok" ? null : "ok");
//                       setUserInputText("");
//                     }}
//                     disabled={!transcribedText}
//                     className="mr-2"
//                   />
//                   {t("OK")}
//                 </label>
//                 <label className="flex items-center text-sm">
//                   <input
//                     type="checkbox"
//                     checked={transcribedStatus === "not_ok"}
//                     onChange={() => {
//                       setTranscribedStatus(transcribedStatus === "not_ok" ? null : "not_ok");
//                     }}
//                     disabled={!transcribedText}
//                     className="mr-2"
//                   />
//                   {t("Not OK")}
//                 </label>
//               </div>
//             </div>

//             {transcribedStatus === "not_ok" && (
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   {t("User Input")} <span className="text-red-500">*</span>
//                 </label>
//                 <textarea
//                   value={userInputText}
//                   onChange={(e) => setUserInputText(e.target.value)}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//                   rows="2"
//                   placeholder={t("Enter the correct text here")}
//                   required
//                 />
//               </div>
//             )}
//           </div>
//         )}

//         {translationText && (
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-1">{t("Translated Text")}</label>
//             <p className="p-2 border border-gray-300 rounded-lg bg-gray-50 text-sm">{translationText}</p>
//           </div>
//         )}

//         <div className="flex flex-col sm:flex-row sm:space-x-6 w-full">
//           <button
//             onClick={handleSave}
//             className={`w-full py-3 rounded-lg mt-4 sm:mt-0 text-xs sm:text-sm text-white ${
//               !audioFile ||
//               !languageCode ||
//               !gender ||
//               !age ||
//               !transcribedText ||
//               !transcribedStatus ||
//               (transcribedStatus === "not_ok" && !userInputText.trim()) ||
//               !uploaderEmail ||
//               isTranscribing ||
//               (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim())
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-green-500 hover:bg-green-600"
//             }`}
//             disabled={
//               !audioFile ||
//               !languageCode ||
//               !gender ||
//               !age ||
//               !transcribedText ||
//               !transcribedStatus ||
//               (transcribedStatus === "not_ok" && !userInputText.trim()) ||
//               isTranscribing ||
//               (selectedCategory === "Channel control" && selectedVoiceControl === "Change Channel by Name" && !channelName.trim())
//             }
//           >
//             {t("Upload")}
//           </button>
//           <button
//             onClick={fetchAudioDetails}
//             className="w-full bg-blue-500 text-white py-3 rounded-lg mt-4 sm:mt-0 hover:bg-blue-600 text-xs sm:text-sm"
//           >
//             {t("Uploaded Audios")}
//           </button>
//         </div>
//         {showUploadedAudios && (
//   <div className="mt-6 relative">
//     {isFetchingAudios ? (
//       <div className="flex justify-center items-center h-64">
//         <div className="loader"></div>
//       </div>
//     ) : (
//       <>
//         <h2 className="text-xl font-semibold text-gray-800 mb-4">{t("Uploaded Audios")}</h2>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Filter by Language")}</label>
//             <select
//               value={filterLanguage}
//               onChange={(e) => setFilterLanguage(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("All Languages")}</option>
//               {uniqueLanguages.map((lang) => (
//                 <option key={lang} value={lang}>
//                   {lang === "english" ? "English" :
//                    lang === "portuguese" ? "Português" :
//                    lang === "spanish" ? "Español" :
//                    lang === "spanish_ar" ? "Español (AR)" :
//                    lang === "spanish_mx" ? "Español (MX)" :
//                    lang === "spanish_cl" ? "Español (CL)" :
//                    lang === "spanish_pe" ? "Español (PE)" :
//                    lang === "french" ? "Français" :
//                    lang === "german" ? "Deutsch" :
//                    lang === "italian" ? "Italiano" :
//                    lang === "chinese_tw" ? "中文 (繁體, 台灣)" :
//                    lang === "chinese_cn" ? "中文 (简体, 中国)" :
//                    lang === "chinese_sg" ? "中文 (简体, 新加坡)" :
//                    lang === "dutch_be" ? "Nederlands (BE)" :
//                    lang === "dutch_nl" ? "Nederlands (NL)" : lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">{t("Filter by Voice Control")}</label>
//             <select
//               value={filterVoiceControl}
//               onChange={(e) => setFilterVoiceControl(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//             >
//               <option value="">{t("All Voice Controls")}</option>
//               {uniqueVoiceControls.map((control) => (
//                 <option key={control} value={control}>{control}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="flex flex-col sm:flex-row sm:space-x-4 mb-4 items-start sm:items-center">
//           <button
//             onClick={prepareZip}
//             className={`w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm ${
//               selectedFiles.length === 0 || isPreparingZip
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-purple-500 hover:bg-purple-600"
//             }`}
//             disabled={selectedFiles.length === 0 || isPreparingZip}
//           >
//             {isPreparingZip ? (
//               <>
//                 <Loader2 className="w-5 h-5 mr-2 inline-block animate-spin" />
//                 {t("Preparing ZIP...")}
//               </>
//             ) : (
//               t("Get ZIP")
//             )}
//           </button>

//           {zipDownloadUrl && (
//             <button
//               onClick={handleZipDownload}
//               className="w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm bg-blue-500 hover:bg-blue-600"
//             >
//               {t("Download ZIP")}
//             </button>
//           )}

//           <div className="flex items-center mt-2 sm:mt-0 sm:ml-4">
//             <input
//               type="checkbox"
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//               className="mr-2 h-4 w-4 text-blue-600"
//             />
//             <label className="text-sm text-gray-700">{t("Select All")}</label>
//           </div>
//         </div>

//         <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg bg-gray-50 p-4">
//           {filteredAudioDetails.length > 0 ? (
//             filteredAudioDetails.map((audio) => (
//               <div
//                 key={audio._id}
//                 className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 mb-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
//               >
//                 <div className="flex items-center flex-1 mb-2 sm:mb-0 space-y-1">
//                   <input
//                     type="checkbox"
//                     checked={selectedFiles.includes(audio.fileName)}
//                     onChange={() => handleFileSelect(audio.fileName)}
//                     className="mr-2 h-4 w-4 text-blue-600"
//                   />
//                   <div>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Language")}:</strong> {audio.audioLanguage} ({audio.languageCode})
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Voice Control")}:</strong> {audio.audiotext}
//                     </p>
//                     {/* Conditionally display ChannelName only when audiotext is "Change Channel by Name" */}
//                     {audio.audiotext === "Change Channel by Name" && (
//                       <p className="text-xs sm:text-sm text-gray-700">
//                         <strong>{t("Channel Name")}:</strong> {audio.ChannelName || "N/A"}
//                       </p>
//                     )}
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Gender & Age")}:</strong> {audio.audioLabel}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700 truncate">
//                       <strong>{t("AI Transcribed Text")}:</strong> {audio.transcribedText}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700 truncate">
//                       <strong>{t("User Input Text")}:</strong> {audio.userInput || "N/A"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Translated Text")}:</strong> {audio.translation || "NA"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Transcription Status")}:</strong>{" "}
//                       <span className={audio.transcribedStatus === "ok" ? "text-green-600" : "text-red-600"}>
//                         {audio.transcribedStatus === "ok" ? "OK" : "Not OK"}
//                       </span>
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Uploader Email")}:</strong> {audio.uploaderEmail || "N/A"}
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-700">
//                       <strong>{t("Upload Date")}:</strong> {new Date(audio.uploadDate).toLocaleString()}
//                     </p>
//                     <p className="text-sm text-gray-700 break-all">
//                       <strong>{t("File Name")}:</strong> {audio.fileName}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   {loading[audio._id] ? (
//                     <div className="loader"></div>
//                   ) : (
//                     <button
//                       onClick={() => toggleAudio(audio.fileName, audio._id)}
//                       className={`px-2 py-1 sm:px-3 sm:py-1 rounded text-white text-xs sm:text-sm ${
//                         playing[audio._id] ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                       }`}
//                     >
//                       {playing[audio._id] ? t("Stop") : t("Play")}
//                     </button>
//                   )}
//                   <button
//                     onClick={() => handleDownload(audio.fileName)}
//                     className="px-2 py-1 sm:px-3 sm:py-1 rounded bg-blue-500 text-white text-xs sm:text-sm hover:bg-blue-600"
//                   >
//                     {t("Download")}
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p className="text-sm text-gray-500">{t("No audio files match the selected filters.")}</p>
//           )}
//         </div>
//       </>
//     )}
//   </div>
// )}
//       </div>
//     </div>
//   );
// }

// export default Audiopage;

//new code
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { decodedToken } from "./utils";
import { useLanguage } from "../language/LanguageContext";
import AudioUpload from "./AudioUpload";
import ChannelUpload from "./ChannelUpload";
import AppUpload from "./AppUpload";

import "./App.css";

function Audiopage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState("audio");

  const decode = decodedToken();
  const isAdmin = decode?.role === "Poweradmin";
  // const isAdmin = decode?.role === "admin";
  const emailUser = localStorage.getItem("email");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    navigate("/");
  };

  const handleAdminPage = () => {
    navigate("/admin");
  };

  return (
    <div className="w-screen h-screen bg-gradient-to-r from-indigo-500 via-purple-600 to-pink-500 flex flex-col justify-start items-center p-4 pt-10 pb-10 overflow-y-auto scroll-mt-32">
      <div className="bg-white p-6 sm:p-8 md:p-10 rounded-xl shadow-xl space-y-6 w-full max-w-5xl">
        <h1 className="text-2xl sm:text-3xl font-semibold text-center mb-6 text-gray-800">
          {t("Audio File Upload")}
        </h1>
        <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            {t("Logout")}
          </button>
          {isAdmin && (
            <button
              onClick={handleAdminPage}
              className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
            >
              {t("Admin Page")}
            </button>
          )}
        </div>

        {/* Tab Navigation */}
        <div className="flex border-b border-gray-200">
          <button
            className={`flex-1 py-2 text-center text-sm font-medium ${
              activeTab === "audio"
                ? "border-b-2 border-blue-500 text-blue-500"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("audio")}
          >
            🔊 {t("Audio Upload")}
          </button>

          <button
            className={`flex-1 py-2 text-center text-sm font-medium ${
              activeTab === "channels"
                ? "border-b-2 border-blue-500 text-blue-500"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("channels")}
          >
            📺 {t("Channel Name Upload")}
          </button>
          <button
            className={`flex-1 py-2 text-center text-sm font-medium ${
              activeTab === "apps"
                ? "border-b-2 border-blue-500 text-blue-500"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("apps")}
          >
            📱 {t("App ID")}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "audio" && (
          <AudioUpload setActiveTab={setActiveTab} emailUser={emailUser} />
        )}
        {activeTab === "channels" && <ChannelUpload emailUser={emailUser} />}
        {activeTab === "apps" && <AppUpload emailUser={emailUser} />}
      </div>
    </div>
  );
}

export default Audiopage;
